



























import {Component, PropSync} from 'vue-property-decorator'
import {Action} from "vuex-class";
import {SelectWings, ToggleWings, InputWings} from 'wings-ui-components';

import { MessageTypeFilter } from '@/store/settings/message_types/types';
import BaseFilter from "@/components/Filter/BaseFilter";
import { notifyError } from '@/utils/notify-helper';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings, InputWings}})
export default class MessageTypesFilter extends BaseFilter<MessageTypeFilter> {

  @PropSync("show") is_show!: boolean;

  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("exportMessageTypes") actionExport: any;

  defaultFilter(): MessageTypeFilter {
    return {
      name: undefined
    };
  }

  created() {
    this.filtered();
  }

  export() {
    this.actionExport(this.filter)
      .catch((error: any) => notifyError(error));
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Message type",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetMessageTypes(this.filter);
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
}
